import ModalMaster from '../components/ModalMaster';
import FormContacts from '../components/forms/FormContacts';
import FormMakeAppointment from '../components/forms/FormMakeAppointment';

if (document.getElementById('main-modal')) {
  new Vue({
    el: '#main-modal',
    data() {
      return {
        modalData: window.modal,
      }
    },
    components: {
      ModalMaster
    },
  });

  $(document).on('click', '.btn-callback', function () {
    window.modal.type = 'contacts';
    $('#main-modal').modal('show');
  });

  $(document).on('click', '.btn-make-appointment, .mob-services-callback', function () {
    window.modal.type = 'make-appointment';
    $('#main-modal').modal('show');
  });

  $(document).on('click', '.login-btn', function () {
    window.modal.type = 'login';
    $('#main-modal').modal('show');
  });
}

if (document.getElementById('contacts-form')) {
  let vm = new Vue({
    el: '#contacts-form',
    components: {
      FormContacts
    },
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/callback.js